<template>
  <Loader :show="loading" v-if="loading"></Loader>
  <MDBRow v-else>
    <MDBCol lg="4" class="mb-4" v-for="(category, i) in mainCategories" :key="`category_${i}`">
      <Card :data="category" class="h-100" :linkText="$t('global.buttons.discover')" />
    </MDBCol>
  </MDBRow>
</template>

<script setup>
import Card from "@/components/General/Card/index";
import Loader from "@/components/General/Loader/index";

import { MDBRow, MDBCol } from "mdb-vue-ui-kit";
import { useStore } from "vuex";
import { computed } from "vue";

const store = useStore();

store.dispatch("loadCategories");

const loading = computed(() => store.getters.getPending);
const currentLocale = computed(() => store.getters.getCurrentLocale);

function pickLocaleValue(val, locale) {
  if (val == null) return "";

  if (typeof val === "string") return val.trim();

  if (typeof val === "object" && !Array.isArray(val)) {
    const tryKeys = [
      locale,
      locale?.replace("_", "-"),
      locale?.replace("-", "_"),
    ].filter(Boolean);

    for (const k of tryKeys) {
      const v = val[k];
      if (typeof v === "string" && v.trim()) return v.trim();
    }

    const first = Object.values(val).find(v => typeof v === "string" && v.trim());
    return (first || "").trim();
  }

  if (Array.isArray(val)) {
    const first = val.find(v => typeof v === "string" && v.trim());
    return (first || "").trim();
  }

  return String(val ?? "");
}

const mainCategories = computed(() =>
  (store.getters.getCategories || [])
    .filter(item => !item.parent_id)
    .map(item => {
      const resolvedName = pickLocaleValue(item.name, currentLocale.value);
      const resolvedImage = pickLocaleValue(item.image, currentLocale.value);
      const resolvedDesc = pickLocaleValue(item.description, currentLocale.value);

      const hasValidLinkObject =
        item.link && typeof item.link === "object" && Object.keys(item.link).length > 0;

      const link =
        hasValidLinkObject
          ? item.link
          : {
            name: "shopCategory",
            params: { id: item.id },
            query: { page: 1 },
          };

      return {
        ...item,
        name: resolvedName,
        image: resolvedImage,
        description: resolvedDesc,
        link,
      };
    })
);
</script>
